import Engine from 'ember-engines/engine';
import loadInitializers from 'ember-load-initializers';
import Resolver from './resolver';
import config from './config/environment';
const {
  modulePrefix
} = config;
const Eng = Engine.extend({
  modulePrefix,
  Resolver,
  dependencies: Object.freeze({
    services: ['authz', 'metrics', 'state', 'store', 'flashMessages', 'linkManager', 'currentAdmin', 'featureConfig', 'localStorage', 'workplaceMetrics', 'abilities', 'impressions'],
    externalRoutes: ['desks', 'createEmployeeScreeningFlow', 'profile', 'liveMap']
  })
});
loadInitializers(Eng, modulePrefix);
export default Eng;